// Tuning constants for the activity/transaction queries, ported from
// deexoptions-mobile-app/hooks/queries/activityKeys.ts

export const ACTIVITY_STALE_TIME = 10_000;
export const ACTIVITY_POLL_INTERVAL = 10_000;
export const DASHBOARD_RECENT_POLL_INTERVAL = 30_000;

export const ACTIVITY_PAGE_LIMIT = 20;
export const ACTIVITY_COIN_PAGE_LIMIT = 30;
export const ACTIVITY_RECENT_LIMIT = 5;
export const DASHBOARD_RECENT_LIMIT = 3;
export const COIN_RECENT_LIMIT = 5;

/**
 * Legacy transaction query keys, invalidated alongside `transactionKeys`.
 *
 * All three transaction lists (activity page, dashboard recents, wallet coin
 * list) now run on the new endpoints, so this is empty — kept rather than
 * deleted so a future migration has an obvious place to list a legacy feed
 * while both systems coexist.
 */
export const legacyActivityKeys: Record<string, readonly unknown[]> = {};
